interface Config {
  style: {
    color: {
      main: string;
      sub: string;
      warning: string;
    };
    backgroundColor: {
      main: string;
      sub: string;
      warning: string;
      body: string;
      header: string;
    };
    basefontFamily: string;
    submenu: {
      fontFamily: string;
    };
  };
  navMenus0: {
    title: string;
    pathname?: string;
    imgsrc: string;
    links?: {
      title: string;
      pathname: string;
    }[];
  }[];
  navMenus1: {
    title: string;
    pathname?: string;
    imgsrc: string;
    links?: {
      title: string;
      pathname: string;
    }[];
  }[];
  inputErrorMessage: {
    [key: string]: {
      type: string;
      pattern: string;
      title: string;
      placeholder: string;
      maxLength?: number;
      max?: number;
    };
  };
}


const config: Config = {
  style: {
    color: {
      main: "#1A4EA1",
      sub: "#0094B5",
      warning: "#FF5757",
    },
    backgroundColor: {
      main: "#1A4EA1",
      sub: "#0094B5",
      warning: "#FF5757",
      body: "#FFFFFF",
      header: "#004A6A",
    },
    basefontFamily: "Inter",
    submenu: {
      fontFamily: "Roboto",
    }
  },
  navMenus0: [
    {
      title: "TOP",
      pathname: "/f0",
      imgsrc: "/images/SideTop.png",
    },
    {
      title: "受注一覧",
      pathname: "/f0/orders",
      imgsrc: "/images/SideRegistOrder.png",
    },
    {
      title: "工程登録",
      pathname: "/f0/product-numbers",
      imgsrc: "/images/SideRegistOrder.png",
    },
    {
      title: "登録済み工程一覧",
      pathname: "/f0/processes",
      imgsrc: "/images/SideRegistProcess.png",
    },
    {
      title: "工程進捗一覧",
      pathname: "/f0/processes-progress",
      imgsrc: "/images/SideRegistProcess.png",
    },
    {
      title: "共有した工程",
      pathname: "/f0/processes-request",
      imgsrc: "/images/SideRegistProcess.png",
    },
    {
      title: "共有された工程",
      pathname: "/f0/processes-requested",
      imgsrc: "/images/SideRegistProcess.png",
    }/* ,
    {
      title: "工程進捗",
      pathname: "/f0/processlist",
      imgsrc: "/images/SideProcessList.png",
    } */,
    {
      title: "マスタ",
      imgsrc: "/images/SideProcessList.png",
      links: [
        { title: "設備", pathname: "/f0/master/equipments" },
        { title: "得意先", pathname: "/f0/master/customers" },
        { title: "仕入先", pathname: "/f0/master/suppliers" },
        { title: "品番", pathname: "/f0/master/product-numbers" },
        { title: "工程", pathname: "/f0/master/processes" },
        { title: "標準工程", pathname: "/f0/master/standard-processes" },
        { title: "不良区分", pathname: "/f0/master/defective-lists" },
        { title: "作業区分", pathname: "/f0/master/working-process-lists" },
        { title: "休憩区分", pathname: "/f0/master/factory-breakings" },
        { title: "休日区分", pathname: "/f0/master/factory-closed-dates" },
      ]
    },
    {
      title: "アカウント情報",
      pathname: "/f0/account",
      imgsrc: "/images/SideAccount.png",
    },
    {
      title: "ユーザー一覧",
      pathname: "/f0/users",
      imgsrc: "/images/SideAccount.png",
    },
    {
      title: "ユーザー情報",
      pathname: "/f0/user",
      imgsrc: "/images/SideAccount.png",
    },
    {
      title: "サービス選択",
      pathname: "/home",
      imgsrc: "/images/SideLogout.png",
    },
    {
      title: "ログアウト",
      pathname: "/home",
      imgsrc: "/images/SideLogout.png",
    }
  ],
  navMenus1: [
    {
      title: "TOP",
      pathname: "/f1",
      imgsrc: "/images/SideTop.png",
    },
    {
      title: "設備一覧",
      pathname: "/f1/equipments",
      imgsrc: "/images/SideRegistOrder.png",
    },
    {
      title: "アカウント情報",
      pathname: "/f1/account",
      imgsrc: "/images/SideAccount.png",
    },
    {
      title: "ユーザー一覧",
      pathname: "/f1/users",
      imgsrc: "/images/SideAccount.png",
    },
    {
      title: "ユーザー情報",
      pathname: "/f1/user",
      imgsrc: "/images/SideAccount.png",
    },
    {
      title: "マスタ",
      imgsrc: "/images/SideProcessList.png",
      links: [
        { title: "設備", pathname: "/f1/master/equipments" },
        { title: "品番", pathname: "/f1/master/product-numbers" },
        { title: "状況定義", pathname: "/f1/master/statuses" },
      ]
    },
    {
      title: "サービス選択",
      pathname: "/home",
      imgsrc: "/images/SideLogout.png",
    }
  ],
  inputErrorMessage: {
    tel: {
      type: "text",
      pattern: "[0-9]+",
      title: "ハイフンなし",
      placeholder: "08012345678",
      maxLength: 11
    },
    alphanumeric: {
      type: "text",
      pattern: "^[ -~]*$",
      title: "半角英数記号のみを入力してください",
      placeholder: "2023aa22-#",
      maxLength: 254
    },
    number: {
      type: "text",
      pattern: "[0-9]+",
      title: "正の整数のみを入力してください",
      placeholder: "123455",
      max: 4294967295,
    },
    branch: {
      type: "text",
      pattern: "[0-9]{2}",
      title: "2桁の数値で入力してください",
      placeholder: "00",
      maxLength: 2
    },
    text: {
      type: "text",
      pattern: ".*",
      title: "文字列を入力してください",
      placeholder: "あa1",
      maxLength: 254
    },
    email: {
      type: "email",
      pattern: ".*",
      title: "メールアドレスを入力してください",
      placeholder: "test@example.com",
      maxLength: 254
    },
    password: {
      type: "password",
      pattern: ".*",
      title: "パスワードを入力してください",
      placeholder: "aB-1",
      maxLength: 254
    },
    color: {
      type: "color",
      pattern: ".*",
      title: "",
      placeholder: "",
      maxLength: 254
    },
    date: {
      type: "date",
      pattern: ".*",
      title: "",
      placeholder: "",
      maxLength: 254
    },
    "datetime-local": {
      type: "datetime-local",
      pattern: ".*",
      title: "",
      placeholder: "",
      maxLength: 254
    },
    time: {
      type: "time",
      pattern: ".*",
      title: "",
      placeholder: "",
      maxLength: 254
    },
    checkbox: {
      type: "checkbox",
      pattern: ".*",
      title: "",
      placeholder: "",
      maxLength: 1
    }
  }
};

export default config;
